import React, { useEffect, useState } from "react";
import DeclineRequestCard from "../../../Components/Profile2/DeclineRequestCard/DeclineRequestCard";
import "./DeclinedRequests.css";
import { BASE_URL } from "../../../BASE_URL";
import { toast, ToastContainer } from "react-toastify";


const DeclinedRequests = ({ horizontal, setValue }) => {
  var declinedRequestsClasses =
    horizontal === true
      ? "profile2_declined_request declined_request_horizontal"
      : "profile2_declined_request declined_request_vertical";

  const [error, setError] = useState(null);
  const [receivedData, setReceivedData] = useState([]);

  const [filterOption, setFilterOption] = useState(""); // State to hold the selected filter option

  const fetchData = async (selectedOption) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/request/display_type`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Request failed");
      }

      const responseData = await response.json();


      // const receivedRequests = responseData.data[0]?.profile || [];
      const iDeclineRequest = responseData.data.iDeclineRequests;

      if (selectedOption == "by me") {
        setReceivedData(responseData.data.iDeclineRequests);
      }

      if (selectedOption == "by they") {
        setReceivedData(responseData.data.theyDeclineRequests);
      }

      if (!selectedOption) {
        setReceivedData(responseData.data.iDeclineRequests);
      }

    } catch (error) {
      setError(error.message);
    }
  };



  useEffect(() => {
    fetchData();
  }, []);

  const reload = () => {
    fetchData();
  }

  const [selectedRequest, setSelectedRequest] = useState('')

  const handleFilterChange = (event) => {
    const selectedOption = event.target.value;
    setSelectedRequest(selectedOption)
    setFilterOption(selectedOption);
    fetchData(selectedOption); // Call fetchData with selected option
  };


  return (
    <>
      <div className="profile_declined_requests_wrapper_top mb-3">
        <ToastContainer />
        <h3 className="profile_requests_title">
          Declined Requests <span>({receivedData.length})</span>
        </h3>
        {/* <p
          onClick={() => {
            setValue("4");
          }}
        >
          View All
        </p> */}
        <select
          name=""
          id=""
          className="i-decline-they-decline"
          onChange={handleFilterChange}
        >
          <option value="by me">I Decline</option>
          <option value="by they">They Decline</option>
        </select>
      </div>
      <div className="profile_declined_requests_wrapper">

        {receivedData.length === 0 ? (
          <div className="nothing-see">
            <p>No decline requests</p>
          </div>
        ) : (
          <div className={declinedRequestsClasses} id="card">
            {[...receivedData].reverse().map((request) => (
              <DeclineRequestCard key={request._id} data={request} selectedRequest={selectedRequest} fetchData={reload} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default DeclinedRequests;
